/**
 * Configurator — Save Build modal (email a link to the current build)
 */

(function () {
  'use strict';

  var WEBHOOK_URL = (window.configuratorSettings && window.configuratorSettings.emailWebhookUrl) || '';
  var CUSTOMER_EMAIL = (window.configuratorSettings && window.configuratorSettings.customerEmail) || '';

  var PANEL_ID = 'cfg-email-panel';
  var RESET_DELAY_MS = 4000;
  var MIN_SUBMIT_MS = 1500;

  var panelOpenedAt = 0;
  var lastTrigger = null;
  var inertRoots = [];
  var closeTimer = null;
  var resolvedCustomerEmail = '';
  var customerEmailFetchPromise = null;
  var STORED_EMAIL_KEY = 'sp_configurator_email';
  var STORED_NAME_KEY = 'sp_configurator_name';
  var STORED_ZIP_KEY = 'sp_configurator_zip';
  var CUSTOMER_EMAIL_QUERY = 'query ConfiguratorCustomerEmail { customer { emailAddress { emailAddress } } }';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  // US ZIP (5 digits, optional +4) or Canadian postal code (A1A 1A1, space or hyphen optional).
  var ZIP_RE = /^(?:\d{5}(?:-?\d{4})?|[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d)$/i;

  var FIELD_IDS = {
    name: 'cfg-email-name',
    email: 'cfg-email-input',
    zip: 'cfg-email-zip',
    consent: 'cfg-email-consent',
  };

  var MESSAGES = {
    nameRequired: 'Please enter your name.',
    emailRequired: 'Please enter your email address.',
    emailInvalid: 'Please enter a valid email address.',
    zipRequired: 'Please enter your zip code.',
    zipInvalid: 'Please enter a valid US zip or Canadian postal code.',
    consentRequired: 'Please agree to the Terms of Service and Privacy Policy to continue.',
    sending: 'Saving…',
    sent: 'Saved',
  };

  function getPanel() {
    return document.getElementById(PANEL_ID);
  }

  function panelMessage(key, fallback) {
    var panel = getPanel();
    var value = panel && panel.dataset ? panel.dataset[key] : '';
    return value || fallback;
  }

  function getDrawer(panel) {
    return panel ? panel.querySelector('[role="dialog"]') || panel.querySelector('.cfg-email-panel__drawer') : null;
  }

  function activateTrap(container, focusEl) {
    if (typeof trapFocus === 'function') {
      trapFocus(container, focusEl || container);
      return;
    }
    if (focusEl && focusEl.focus) focusEl.focus();
  }

  function deactivateTrap() {
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
  }

  function setPageInert(exceptEl, isInert) {
    if (!isInert) {
      inertRoots.forEach(function (child) {
        child.removeAttribute('inert');
      });
      inertRoots = [];
      return;
    }

    inertRoots = [];
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === exceptEl) {
        child.removeAttribute('inert');
        return;
      }
      child.setAttribute('inert', '');
      inertRoots.push(child);
    });
  }

  function isDisplayed(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function resolveFocusTarget(preferred, selector) {
    if (isDisplayed(preferred)) return preferred;
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (isDisplayed(nodes[i])) return nodes[i];
    }
    return preferred || nodes[0] || null;
  }

  function setTriggerExpanded(trigger, isOpen) {
    document.querySelectorAll('.js-cfg-email-build-trigger').forEach(function (btn) {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.setAttribute('aria-controls', PANEL_ID);
    });
  }

  function closeOtherShareDialogs() {
    if (window.ConfiguratorShareModals && typeof window.ConfiguratorShareModals.close === 'function') {
      window.ConfiguratorShareModals.close({ silent: true });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Stored values / customer prefill                                    */
  /* ------------------------------------------------------------------ */

  function readStored(key, validator) {
    try {
      var stored = localStorage.getItem(key) || '';
      return validator ? (validator(stored) ? stored : '') : stored;
    } catch (e) {
      return '';
    }
  }

  function writeStored(key, value) {
    try {
      if (value) localStorage.setItem(key, String(value).trim());
    } catch (e) { /* storage blocked */ }
  }

  function getStoredEmail() {
    return readStored(STORED_EMAIL_KEY, function (v) { return EMAIL_RE.test(v); });
  }

  function storeForReturnVisits(name, email, zip) {
    if (email && EMAIL_RE.test(email)) writeStored(STORED_EMAIL_KEY, email);
    if (name) writeStored(STORED_NAME_KEY, name);
    if (zip && ZIP_RE.test(zip)) writeStored(STORED_ZIP_KEY, zip);
  }

  function getCustomerEmailFromSettings() {
    return resolvedCustomerEmail ||
      (window.configuratorSettings && window.configuratorSettings.customerEmail) ||
      CUSTOMER_EMAIL ||
      getStoredEmail() ||
      '';
  }

  function applyValueToInput(input, value) {
    if (!input || !value || input.value.trim()) return false;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function parseJsonResponse(res, step) {
    return res.text().then(function (text) {
      if (!text || !text.trim()) throw new Error(step + ' empty body HTTP ' + res.status);
      try {
        return JSON.parse(text);
      } catch (e) {
        throw new Error(step + ' invalid JSON HTTP ' + res.status);
      }
    });
  }

  function fetchDiscoveryConfig() {
    return fetch('/.well-known/customer-account-api', { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 204) return null;
        return parseJsonResponse(res, 'discovery');
      })
      .catch(function () {
        return null;
      });
  }

  function attemptStorefrontSessionSync() {
    var settings = window.configuratorSettings || {};
    var loginUrl = settings.accountLoginUrl || '/account/login';
    var returnTo = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
    var separator = loginUrl.indexOf('?') >= 0 ? '&' : '?';
    var syncUrl = loginUrl + separator + 'return_to=' + returnTo;

    return fetch(syncUrl, {
      method: 'GET',
      credentials: 'include',
      redirect: 'follow',
    }).catch(function () { });
  }

  function extractEmailFromPayload(payload) {
    if (!payload || payload.errors) return '';
    return (payload.data &&
      payload.data.customer &&
      payload.data.customer.emailAddress &&
      payload.data.customer.emailAddress.emailAddress) || '';
  }

  function tryGraphqlEndpoint(url, step) {
    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: CUSTOMER_EMAIL_QUERY }),
    })
      .then(function (res) { return parseJsonResponse(res, step); })
      .then(function (payload) {
        return extractEmailFromPayload(payload);
      })
      .catch(function () {
        return '';
      });
  }

  function fetchCustomerEmailFromAccountApi() {
    var settings = window.configuratorSettings || {};
    var shopId = settings.shopId;

    return fetchDiscoveryConfig()
      .then(function (config) {
        var graphqlUrl = config && config.graphql_api;
        if (graphqlUrl) {
          return tryGraphqlEndpoint(graphqlUrl, 'discovery-graphql');
        }
        return '';
      })
      .then(function (email) {
        if (email) return email;
        return tryGraphqlEndpoint('/customer/api/2025-01/graphql', 'storefront-graphql');
      })
      .then(function (email) {
        if (email) return email;
        if (!shopId) return '';
        return tryGraphqlEndpoint(
          'https://shopify.com/' + shopId + '/account/customer/api/2025-01/graphql',
          'shopify-com-graphql'
        );
      });
  }

  function resolveCustomerEmail() {
    var existing = getCustomerEmailFromSettings();
    if (existing) return Promise.resolve(existing);
    if (customerEmailFetchPromise) return customerEmailFetchPromise;

    customerEmailFetchPromise = fetchCustomerEmailFromAccountApi()
      .then(function (email) {
        if (email) return email;
        return attemptStorefrontSessionSync().then(function () {
          return fetchCustomerEmailFromAccountApi();
        });
      })
      .then(function (email) {
        if (email) {
          resolvedCustomerEmail = email;
          if (window.configuratorSettings) window.configuratorSettings.customerEmail = email;
        }
        return email || '';
      })
      .catch(function () {
        return '';
      })
      .finally(function () {
        customerEmailFetchPromise = null;
      });

    return customerEmailFetchPromise;
  }

  function prefillFields() {
    applyValueToInput(document.getElementById(FIELD_IDS.name), readStored(STORED_NAME_KEY));
    applyValueToInput(document.getElementById(FIELD_IDS.zip), readStored(STORED_ZIP_KEY, function (v) { return ZIP_RE.test(v); }));
    var settingsEmail = getCustomerEmailFromSettings();
    if (settingsEmail) applyValueToInput(document.getElementById(FIELD_IDS.email), settingsEmail);
  }

  function prefillAsync() {
    prefillFields();
    return resolveCustomerEmail().then(function () {
      prefillFields();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Open / close                                                        */
  /* ------------------------------------------------------------------ */

  function openPanel(trigger) {
    var panel = getPanel();
    if (!panel) return;

    closeOtherShareDialogs();
    clearTimeout(closeTimer);

    lastTrigger = trigger || lastTrigger;
    panel.removeAttribute('hidden');
    panelOpenedAt = Date.now();
    document.body.classList.add('cfg-email-modal-open');
    setTriggerExpanded(lastTrigger, true);
    setPageInert(panel, true);

    prefillAsync();

    var drawer = getDrawer(panel);
    var firstInput = document.getElementById(FIELD_IDS.name) || document.getElementById(FIELD_IDS.email);
    if (drawer) activateTrap(drawer, firstInput || drawer);
  }

  function closePanel(options) {
    var panel = getPanel();
    if (!panel || panel.hasAttribute('hidden')) return;

    clearTimeout(closeTimer);
    var restoreFocus = !options || !options.silent;
    var trigger = resolveFocusTarget(lastTrigger, '.js-cfg-email-build-trigger');
    deactivateTrap();
    panel.setAttribute('hidden', '');
    document.body.classList.remove('cfg-email-modal-open');
    resetForm();
    setPageInert(null, false);
    setTriggerExpanded(null, false);
    if (restoreFocus && trigger) trigger.focus();
  }

  function onKeyDown(e) {
    var panel = getPanel();
    if (!panel || panel.hasAttribute('hidden')) return;
    if (e.key !== 'Escape' && e.key !== 'Esc' && e.code !== 'Escape') return;
    e.preventDefault();
    e.stopPropagation();
    closePanel();
  }

  /* ------------------------------------------------------------------ */
  /* UI state                                                            */
  /* ------------------------------------------------------------------ */

  function submitButton() {
    return document.querySelector('.cfg-email-panel__submit');
  }

  function submitLabelEl() {
    return document.querySelector('.js-cfg-email-label');
  }

  function defaultSubmitLabel() {
    return panelMessage('submitLabel', 'Save Build');
  }

  function setSubmitting(isSubmitting) {
    var btn = submitButton();
    var label = submitLabelEl();
    if (!btn) return;
    var spinner = btn.querySelector('.loading__spinner');
    if (isSubmitting) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('loading');
      btn.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
      if (label) label.textContent = MESSAGES.sending;
    } else {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
      btn.disabled = false;
      if (spinner) spinner.classList.add('hidden');
      if (label) label.textContent = defaultSubmitLabel();
    }
  }

  function setSubmitSent() {
    var btn = submitButton();
    var label = submitLabelEl();
    if (!btn) return;
    var spinner = btn.querySelector('.loading__spinner');
    btn.setAttribute('aria-disabled', 'true');
    btn.removeAttribute('aria-busy');
    btn.classList.remove('loading');
    btn.disabled = true;
    if (spinner) spinner.classList.add('hidden');
    if (label) label.textContent = MESSAGES.sent;
  }

  function fieldWrapper(key) {
    var panel = getPanel();
    return panel ? panel.querySelector('[data-field="' + key + '"]') : null;
  }

  function showFieldError(key, message) {
    var wrapper = fieldWrapper(key);
    var input = document.getElementById(FIELD_IDS[key]);
    var el = wrapper ? wrapper.querySelector('.cfg-email-panel__error') : null;
    if (wrapper) wrapper.classList.add('cfg-email-panel__field--error');
    if (el) {
      el.textContent = message;
      el.removeAttribute('hidden');
    }
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      if (el && el.id) input.setAttribute('aria-errormessage', el.id);
    }
  }

  function clearFieldError(key) {
    var wrapper = fieldWrapper(key);
    var input = document.getElementById(FIELD_IDS[key]);
    var el = wrapper ? wrapper.querySelector('.cfg-email-panel__error') : null;
    if (wrapper) wrapper.classList.remove('cfg-email-panel__field--error');
    if (el) {
      el.textContent = '';
      el.setAttribute('hidden', '');
    }
    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-errormessage');
    }
  }

  function clearAllFieldErrors() {
    Object.keys(FIELD_IDS).forEach(clearFieldError);
  }

  function showFeedback(message, type) {
    var el = document.getElementById('cfg-email-feedback');
    if (!el) return;
    el.textContent = message;
    el.className = 'cfg-email-panel__feedback cfg-email-panel__feedback--' + type;
    el.removeAttribute('hidden');
  }

  function hideFeedback() {
    var el = document.getElementById('cfg-email-feedback');
    if (!el) return;
    el.textContent = '';
    el.className = 'cfg-email-panel__feedback';
    el.setAttribute('hidden', '');
  }

  function setSuccessState(isSuccess) {
    var panel = getPanel();
    if (panel) panel.classList.toggle('cfg-email-panel--success', !!isSuccess);
  }

  function resetForm() {
    var form = document.getElementById('cfg-email-form');
    if (form) form.reset();
    hideFeedback();
    setSuccessState(false);
    setSubmitting(false);
    clearAllFieldErrors();
    prefillAsync();
  }

  /* ------------------------------------------------------------------ */
  /* Validation                                                          */
  /* ------------------------------------------------------------------ */

  function readValues() {
    var get = function (key) {
      var el = document.getElementById(FIELD_IDS[key]);
      return el ? el.value : '';
    };
    var consentEl = document.getElementById(FIELD_IDS.consent);
    var faxInput = document.getElementById('cfg-email-fax');
    return {
      name: get('name').trim(),
      email: get('email').trim(),
      zip: get('zip').trim().toUpperCase(),
      consent: !!(consentEl && consentEl.checked),
      fax: faxInput ? faxInput.value : '',
    };
  }

  function validate(values) {
    var errors = {};
    if (!values.name) errors.name = MESSAGES.nameRequired;
    if (!values.email) errors.email = MESSAGES.emailRequired;
    else if (!EMAIL_RE.test(values.email)) errors.email = MESSAGES.emailInvalid;
    if (!values.zip) errors.zip = MESSAGES.zipRequired;
    else if (!ZIP_RE.test(values.zip)) errors.zip = MESSAGES.zipInvalid;
    if (!values.consent) errors.consent = MESSAGES.consentRequired;
    return errors;
  }

  /* ------------------------------------------------------------------ */
  /* Payload                                                             */
  /* ------------------------------------------------------------------ */

  function parseMoneyText(text) {
    var match = String(text || '').match(/\$?\s*([0-9][0-9,]*\.?[0-9]*)/);
    return match ? parseFloat(match[1].replace(/,/g, '')) : null;
  }

  function readDueToday() {
    var deposit = document.querySelector('.price__deposit .price-item');
    if (deposit) {
      var fromDeposit = parseMoneyText(deposit.textContent);
      if (fromDeposit !== null) return fromDeposit;
    }
    var row = document.querySelector('.cart-item-price__row--due .cart-item-price__value');
    if (row) return parseMoneyText(row.textContent);
    return null;
  }

  function buildPayload(values) {
    var settings = window.configuratorSettings || {};
    var product = settings.product || {};
    var panel = getPanel();
    var url = '';
    var vehicle = '';
    var variant = '';
    var build = null;

    if (window.ConfiguratorUrlState && typeof window.ConfiguratorUrlState.buildShareUrl === 'function') {
      try {
        url = window.ConfiguratorUrlState.buildShareUrl();
      } catch (e) { /* share URL unavailable */ }
    }
    if (!url) url = window.location.href;

    if (window.ConfiguratorSerializer) {
      if (typeof window.ConfiguratorSerializer.serializeForWebhook === 'function') {
        try {
          build = window.ConfiguratorSerializer.serializeForWebhook();
        } catch (e) { /* build snapshot unavailable */ }
      }

      if (typeof window.ConfiguratorSerializer.serialize === 'function') {
        try {
          var state = window.ConfiguratorSerializer.serialize();
          vehicle = (state.vehicle && (state.vehicle.label || state.vehicle.value)) || '';
          variant = state.variantId || '';
        } catch (e) { /* serialize unavailable */ }
      }
    }

    if (build) {
      if (!vehicle && build.vehicle) {
        vehicle = build.vehicle.label || build.vehicle.value || '';
      }
      if (!variant && build.variant && build.variant.id) {
        variant = build.variant.id;
      }
    }

    if (vehicle && window.ConfiguratorBuildEmailSummary &&
      typeof window.ConfiguratorBuildEmailSummary.formatVehicleLabel === 'function') {
      vehicle = window.ConfiguratorBuildEmailSummary.formatVehicleLabel(vehicle);
    }

    var eventFields = {};
    if (build && window.ConfiguratorBuildEmailSummary &&
      typeof window.ConfiguratorBuildEmailSummary.buildEventFields === 'function') {
      try {
        eventFields = window.ConfiguratorBuildEmailSummary.buildEventFields(build, url);
      } catch (e) { /* summary fields unavailable */ }
    }

    var submittedAt = Date.now();
    var dueToday = readDueToday();

    return {
      name: values.name,
      email: values.email,
      zip: values.zip,
      consent: values.consent ? 'yes' : '',
      consent_text: (panel && panel.dataset.consentText) || '',
      terms_url: (panel && panel.dataset.termsUrl) || '',
      privacy_url: (panel && panel.dataset.privacyUrl) || '',
      url: url,
      page_url: (build && build.product && build.product.pageUrl) || (window.location.origin + window.location.pathname),
      product_handle: product.handle || (build && build.product && build.product.handle) || '',
      product_id: product.id ? String(product.id) : '',
      vehicle: vehicle,
      variant: variant,
      due_today: dueToday !== null ? String(dueToday) : '',
      build: build,
      build_json: build ? JSON.stringify(build) : '',
      eventFields: eventFields,
      fax: values.fax || '',
      openedAt: panelOpenedAt,
      submittedAt: submittedAt,
      timestamp: new Date(submittedAt).toISOString(),
      event_id: submittedAt + '-' + Math.random().toString(36).slice(2, 10),
    };
  }

  function payloadToFormBody(payload) {
    var params = new URLSearchParams();
    var eventFields = payload.eventFields || {};
    var shareUrl = payload.url || eventFields.build_url || '';
    var vehicleLabel = eventFields.vehicle_label || payload.vehicle || '';

    // Contact fields
    params.set('name', payload.name || '');
    params.set('email', payload.email || '');
    params.set('zip', payload.zip || '');
    params.set('consent', payload.consent || '');
    params.set('consent_text', payload.consent_text || '');
    params.set('terms_url', payload.terms_url || '');
    params.set('privacy_url', payload.privacy_url || '');

    // Links and identifiers
    if (shareUrl) {
      params.set('build_url', shareUrl);
      params.set('url', shareUrl);
    }
    params.set('page_url', payload.page_url || '');
    params.set('product_handle', payload.product_handle || '');
    params.set('product_id', payload.product_id || '');
    if (vehicleLabel) {
      params.set('vehicle_label', vehicleLabel);
    }
    params.set('variant', String(payload.variant || ''));
    params.set('due_today', payload.due_today || '');

    // Timing / dedupe / spam guard
    params.set('timestamp', payload.timestamp || '');
    params.set('openedAt', String(payload.openedAt || ''));
    params.set('submittedAt', String(payload.submittedAt || ''));
    params.set('event_id', payload.event_id || String(payload.submittedAt || Date.now()));
    params.set('fax', payload.fax || '');

    // Full build snapshot (JSON) plus the flat summary fields
    params.set('build_json', payload.build_json || '');
    Object.keys(eventFields).forEach(function (key) {
      var value = eventFields[key];
      if (value === null || value === undefined || value === '') return;
      if (key === 'build_url' && shareUrl) return;
      if (key === 'vehicle_label' && vehicleLabel) return;
      params.set(key, String(value));
    });

    return params;
  }

  function postToWebhook(payload) {
    // Browser → Zapier: JSON POST often arrives as text/plain and Zapier ignores it.
    // application/x-www-form-urlencoded is valid for Catch Hooks and works with no-cors.
    // NOTE: no-cors responses are opaque, so only network failures reach .catch().
    return fetch(WEBHOOK_URL, {
      method: 'POST',
      mode: 'no-cors',
      body: payloadToFormBody(payload),
    });
  }

  /* ------------------------------------------------------------------ */
  /* Submit                                                              */
  /* ------------------------------------------------------------------ */

  function showSuccessFeedback(values) {
    setSubmitSent();
    storeForReturnVisits(values.name, values.email, values.zip);
    setSuccessState(true);
    showFeedback(panelMessage('successMessage', 'Link sent! Check your inbox for an email with a direct link back to your build.'), 'success');
    document.dispatchEvent(new CustomEvent('configurator:buildSaved', {
      detail: { email: values.email, name: values.name, zip: values.zip },
    }));
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closePanel, RESET_DELAY_MS);
  }

  function isLikelySpam(values) {
    if (values.fax && values.fax.trim()) return true;
    if (panelOpenedAt && Date.now() - panelOpenedAt < MIN_SUBMIT_MS) return true;
    return false;
  }

  function onFormSubmit(e) {
    e.preventDefault();

    var values = readValues();
    clearAllFieldErrors();
    hideFeedback();

    var errors = validate(values);
    var errorKeys = Object.keys(errors);
    if (errorKeys.length) {
      errorKeys.forEach(function (key) { showFieldError(key, errors[key]); });
      var firstInput = document.getElementById(FIELD_IDS[errorKeys[0]]);
      if (firstInput) firstInput.focus();
      return;
    }

    if (!WEBHOOK_URL) {
      showFeedback(panelMessage('notConfiguredMessage', 'Saving builds is not set up yet. Please try again later.'), 'error');
      return;
    }

    if (isLikelySpam(values)) {
      // Silently "succeed" so bots get no signal.
      showSuccessFeedback(values);
      return;
    }

    setSubmitting(true);

    var payload = buildPayload(values);

    postToWebhook(payload)
      .then(function () {
        showSuccessFeedback(values);
      })
      .catch(function () {
        setSubmitting(false);
        showFeedback(panelMessage('errorMessage', 'Something went wrong. Please try again.'), 'error');
      });
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                                */
  /* ------------------------------------------------------------------ */

  function bindFieldListeners() {
    Object.keys(FIELD_IDS).forEach(function (key) {
      var input = document.getElementById(FIELD_IDS[key]);
      if (!input) return;
      var eventName = input.type === 'checkbox' ? 'change' : 'input';
      input.addEventListener(eventName, function () {
        clearFieldError(key);
      });
    });
  }

  function init() {
    var panel = getPanel();
    var triggers = document.querySelectorAll('.js-cfg-email-build-trigger');

    if (!panel) {
      if (triggers.length) {
        console.warn('[Configurator] Save Build modal markup (#' + PANEL_ID + ') is missing; triggers are inert.');
      }
      return;
    }

    // Move the panel to <body> so the inert / overlay logic covers the whole page.
    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }

    triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', PANEL_ID);
      trigger.addEventListener('click', function () {
        if (!panel.hasAttribute('hidden')) {
          closePanel();
          return;
        }
        openPanel(trigger);
      });
    });

    var closeBtn = panel.querySelector('.cfg-email-panel__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { closePanel(); });
    panel.addEventListener('click', function (e) {
      if (e.target === panel) closePanel();
    });

    var form = document.getElementById('cfg-email-form');
    if (form) form.addEventListener('submit', onFormSubmit);

    bindFieldListeners();
    prefillAsync();

    document.addEventListener('keydown', onKeyDown, true);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      if (getCustomerEmailFromSettings()) return;
      resolvedCustomerEmail = '';
      prefillAsync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ConfiguratorEmailBuild = {
    open: openPanel,
    close: closePanel,
  };

})();
